export default "__VITE_ASSET__CFbZBTXz__"